PF.List.Delete = class Delete extends PF.Trait
	{
	initTrait()
		{
		this.dom.delete.on('click', () => this.deleteSelected());
		}

	deleteSelected()
		{
		for (let i = 0; i < this.selected.length; i++)
			{
			this.selected[i].model.markForDelete();
			}
		if (this.toastOnDelete === true)
			{
			this.models.once('delete-marked-success', () => app.toast(this.toastOnDeleteText));
			}
		this.models.delete();
		}
	};